import React from 'react';
import GoBackComponents from './go-back.components';

interface GoBackContentProps {
  onClickHandler: () => void;
}
const {
  Container,
  GoBackButton,
  GoBackIconContainer,
  GoBackIcon,
  StyledText
} = GoBackComponents;

const GoBackContent: React.FunctionComponent<GoBackContentProps> = ({
  onClickHandler
}) => {
  return (
    <Container>
      <GoBackButton onClick={onClickHandler}>
        <GoBackIconContainer>
          <GoBackIcon />
        </GoBackIconContainer>
        <StyledText tParams="app.goBack" />
      </GoBackButton>
    </Container>
  );
};

export default GoBackContent;
